<div class="backdrop" (click)="onClose()"></div>
<div class="confirmation-box">
    <div class="confirmation-header">
        <p>Confirm Laboratory/Organization</p>
        <em class="material-icons" (click)="onClose()">close</em>
    </div>

    <div class="confirmation-box-content">
        <div style="margin-bottom: 1em;">
            <strong>Name: </strong> <span>{{ name }}</span>
            <br />
            <strong>CAP #: </strong> {{ capNumber }}
            <br />
            <strong>Kit #: </strong> {{ kitNumber }}
            <br />
            <ng-container *ngIf="lab.orgName">
                <strong>Laboratory/Organization: </strong><span>{{ lab.orgName }}</span>
                <span *ngIf="lab.lbn2">, {{ lab.lbn2 }}</span>
                <span *ngIf="lab.address1">, {{ lab.address1 }}</span>
                <span *ngIf="lab.address2">, {{ lab.address2 }}</span>
                <span *ngIf="lab.address3">, {{ lab.address3 }}</span>
                <span *ngIf="lab.address4">, {{ lab.address4 }}</span>
                <span *ngIf="lab.city">, {{ lab.city }}</span>
                <span *ngIf="lab.state">, {{ lab.state }}</span>
                <span *ngIf="lab.postalCode">, {{ lab.postalCode }}</span>
            </ng-container>
        </div>

        <p>
            Once you press <strong>Confirm</strong>, the Kit # will be associated with your name — no one else can claim
            the kit for credit.
        </p>

        <div class="confirmation-box-actions">
            <button class="btn btn-primary" (click)="onConfirm()">Confirm</button>
            <button class="btn" (click)="onClose()" style="color: #009bbf;">Cancel</button>
        </div>
    </div>
</div>
